import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {PointGeometryPointSet1} from "#template/nodes/geometry-graph/attribute/primitive/point-geometry-point-set-1"
import {PointGeometryPointSet2} from "#template/nodes/geometry-graph/attribute/primitive/point-geometry-point-set-2"
import {PointGeometryPointSet3} from "#template/nodes/geometry-graph/attribute/primitive/point-geometry-point-set-3"
import {PointGeometryLinePoints1} from "#template/nodes/geometry-graph/attribute/primitive/point-geometry-line-points-1"
import {PointGeometryLinePoints2} from "#template/nodes/geometry-graph/attribute/primitive/point-geometry-line-points-2"
import {PointGeometryLinePoints3} from "#template/nodes/geometry-graph/attribute/primitive/point-geometry-line-points-3"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PrimitiveParameters} from "#template/nodes/geometry-graph/attribute/primitive/geometry-primitive-node"
import {GeometryPrimitiveNode} from "#template/nodes/geometry-graph/attribute/primitive/geometry-primitive-node"

export type PointGeometryPrimitiveParameters = PrimitiveParameters<
    PointGeometryPointSet1 | PointGeometryPointSet2 | PointGeometryPointSet3 | PointGeometryLinePoints1 | PointGeometryLinePoints2 | PointGeometryLinePoints3
>

const definition: TemplateNodeDefinition<PointGeometryPrimitiveParameters> = {
    nodeClass: "PointGeometryPrimitive",
    validation: {
        parameters: z.object({
            name: z.string(),
            primitive: z.union([
                graphNode(PointGeometryPointSet1),
                graphNode(PointGeometryPointSet2),
                graphNode(PointGeometryPointSet3),
                graphNode(PointGeometryLinePoints1),
                graphNode(PointGeometryLinePoints2),
                graphNode(PointGeometryLinePoints3),
            ]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryPrimitive
    extends GeometryPrimitiveNode<
        0,
        | PointGeometryPointSet1
        | PointGeometryPointSet2
        | PointGeometryPointSet3
        | PointGeometryLinePoints1
        | PointGeometryLinePoints2
        | PointGeometryLinePoints3
    >
    implements PointGeometryAttributeLikeNode
{
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
